import React, { useState } from "react";
import PageHeader from "./components/PagesHeaderComponent/PageHeader";
import Card from 'react-bootstrap/Card';

const Proceeding = () => {

    const data = [
        {
            title: "Standardized Procedures",
        },
        {
            title: "Video Recording of Meetings",
        },
        {
            title: "Publishing Resolution Results",

        }

    ]

    return (
        <>

            <PageHeader tabs={[{ name: "Announcements", route: "/Announcements" }, { name: "Proceeding", route: "/Proceeding" }]} heading="Proceeding" />
            <div className="content_wrap">
                <div className="proceeding">
                    <div className='container'>

                    {data.map((e) => {
							return <>
								<Card>
										<div>
											<h4>{e.title}</h4>
										</div>
										<button className="rounded_btn" variant="primary">View</button>
								</Card>
							</>
						})}

                    </div>

                </div>
            </div >
        </>
    );
};

export default Proceeding;
